import React from "react";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";

import {Order} from "@/types";
import {InsightTable, InsightTableHeader} from "@/types";


interface SortableHeaderProps {
  header: InsightTableHeader[];
  column: string;
  order: Order;
  onSort: (event: React.MouseEvent<unknown>, property: keyof InsightTable) => void;
}

const SortableHeader: React.FC<SortableHeaderProps> = ({ header, column, order, onSort }) => {

  const createSortHandler = (property: keyof InsightTable) => (event: React.MouseEvent<unknown>) => {
    onSort(event, property);
  }

  return (
    <TableHead>
      <TableRow>
        {header.map((cell) => (
          <TableCell
            key={cell.id}
            align={cell.numeric ? 'right' : 'left'}
            padding={cell.disablePadding ? 'none' : 'normal'}
            sortDirection={column === cell.id ? order : false}
            sx={{
              width: cell.width,
              fontFamily: 'cera-pro-bold'
            }}
          >
            <TableSortLabel
              active={column === cell.id}
              direction={column === cell.id ? order : 'asc'}
              onClick={createSortHandler(cell.id)}
            >
              {cell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default SortableHeader;
